import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { SignupService } from "../../../services/signup.service";
import { validatePassword } from "../../../../common/utilities/CustomValidator";

@Component({
  selector: 'app-merchant-basic-info',
  templateUrl: './merchant-basic-info.component.html',
  styleUrls: ['./merchant-basic-info.component.css']
})
export class MerchantBasicInfoComponent {

  public showPasswordFieldText = false;
  public signUpForm: FormGroup;

  // showNameError: boolean = false;
  // showBusinessNameError: boolean = false;
  // showEmailError: boolean = false;
  // showPasswordError: boolean = false;

  serverError: string|null = null



  constructor(private formBuilder: FormBuilder, public signupService: SignupService, private router: Router) {  }
  ngOnInit() {
    this.signupService.currentStepBs.next(this.signupService.Step.BASIC_INFO);
    this.signupService.disableBackButton = false
    this.signupService.disableNextButton = false

    this.signUpForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(256)]],
      businessName: ['', [Validators.required, Validators.maxLength(256)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(320)]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(64), validatePassword]],
      agreeToTerms: [false, [Validators.requiredTrue]]
    });
    this.signupService.signUpForm = this.signUpForm
  }

  get name() { return this.signUpForm.get('name'); }
  get businessName() { return this.signUpForm.get('businessName'); }
  get email() { return this.signUpForm.get('email'); }
  get password() { return this.signUpForm.get('password'); }
  get agreeToTerms() { return this.signUpForm.get('agreeToTerms'); }

  togglePasswordShowButtonClicked () {
    this.showPasswordFieldText = !this.showPasswordFieldText;
  }

  signUpFormSubmitted() {
    // this.signUpForm
    console.log("signUpFormSubmitted method")
    console.log(this.signUpForm)

    this.router.navigate(["/email-confirmation"])
  }
}
